import { Link } from "react-router";

export interface Crumb {
  label: string;
  to?: string;
}

export function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-4 flex items-center gap-1 text-sm font-medium">
      {items.map((item, i) => (
        <span key={i} style={{ display: "contents" }}>
          {i > 0 && <span className="select-none font-normal text-muted-foreground">/</span>}
          {item.to ? (
            <Link
              to={item.to}
              className="rounded-md px-2.5 py-1 text-muted-foreground transition-colors hover:bg-foreground/5 hover:text-foreground"
            >
              {item.label}
            </Link>
          ) : (
            <span className="px-2.5 py-1 text-foreground">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
